// extracted by mini-css-extract-plugin
module.exports = {"comment_button":"CommentOnOrderFormTheming_comment_button__1eWnU"};